import { gql } from '@apollo/client';

// Consulta para obtener los destacados de la página principal
export const GET_HOMEPAGE_HIGHLIGHTS = gql`
  query GetHomepageHighlights {
    homepageHighlights(where: { isVisible: { equals: true } }, orderBy: { order: asc }) {
      id
      title
      type
      description
      ctaText
      ctaUrl
      order
      isVisible
      image {
        publicUrl
      }
      relatedPackage {
        id
        title
        slug
        priceFrom
        imageCover {
          publicUrl
        }
      }
      relatedPost {
        id
        title
        slug
        excerpt
        coverImage {
          publicUrl
        }
      }
      relatedDestination {
        id
        title
        slug
        imageCover {
          publicUrl
        }
        country {
          name
        }
      }
    }
  }
`;

// Consulta para obtener paquetes destacados
export const GET_FEATURED_PACKAGES = gql`
  query GetFeaturedPackages {
    packages(where: { isFeatured: { equals: true } }) {
      id
      title
      slug
      description
      priceFrom
      durationDays
      durationNights
      highlights
      imageCover {
        publicUrl
      }
      thumbnail {
        publicUrl
      }
      destinations {
        id
        title
        slug
        country {
          id
          name
          slug
        }
      }
      includes {
        id
        title
        description
        type
        icon {
          publicUrl
        }
      }
    }
  }
`;

// Consulta para obtener todos los paquetes
export const GET_ALL_PACKAGES = gql`
  query GetAllPackages {
    packages {
      id
      title
      slug
      description
      priceFrom
      durationDays
      durationNights
      highlights
      imageCover {
        publicUrl
      }
      thumbnail {
        publicUrl
      }
      destinations {
        id
        title
        slug
        country {
          id
          name
          slug
        }
      }
      includes {
        id
        title
        description
        type
        icon {
          publicUrl
        }
      }
    }
  }
`;

// Consulta para obtener un paquete específico por slug
export const GET_PACKAGE_BY_SLUG = gql`
  query GetPackageBySlug($slug: String!) {
    package(where: { slug: $slug }) {
      id
      title
      slug
      description
      priceFrom
      durationDays
      durationNights
      highlights
      whatsappMessageTemplate
      imageCover {
        publicUrl
      }
      thumbnail {
        publicUrl
      }
      galleryImages {
        id
        altText
        image {
          publicUrl
        }
      }
      destinations {
        id
        title
        slug
        imageCover {
          publicUrl
        }
        country {
          id
          name
          slug
          bandera {
            publicUrl
          }
        }
      }
      includes {
        id
        title
        description
        type
        icon {
          publicUrl
        }
      }
      dates {
        id
        tipoTarifa
        startDate
        endDate
        currency
        priceSGL
        priceDBL
        priceTPL
        priceCPL
        priceCHD
        priceINF
        isAvailable
        diasDeLaSemana
        sena
        maximoDeCuotas
        cuotasPostSena
        label {
          id
          name
          slug
        }
      }
      accommodations {
        id
        name
        slug
        category
        description
        coverImage {
          publicUrl
        }
        thumbnail {
          publicUrl
        }
        destination {
          id
          title
          slug
          country {
            id
            name
            slug
            bandera {
              publicUrl
            }
          }
        }
      }
    }
  }
`;

// Consulta para obtener todos los destinos
export const GET_ALL_DESTINATIONS = gql`
  query GetAllDestinations {
    destinations {
      id
      title
      slug
      description
      destinationIntro
      top5ReasonsTitle
      top5ReasonsContent
      howToGetAround
      imageCover {
        publicUrl
      }
      thumbnail {
        publicUrl
      }
      country {
        id
        name
        slug
        bandera {
          publicUrl
        }
        region {
          id
          name
          slug
        }
      }
      tips {
        id
        title
        description
        type
        icon
      }
      packages {
        id
        title
        slug
        priceFrom
        imageCover {
          publicUrl
        }
      }
    }
  }
`;

// Consulta para obtener un destino específico por slug
export const GET_DESTINATION_BY_SLUG = gql`
  query GetDestinationBySlug($slug: String!) {
    destination(where: { slug: $slug }) {
      id
      title
      slug
      description
      destinationIntro
      top5ReasonsTitle
      top5ReasonsContent
      howToGetAround
      imageCover {
        publicUrl
      }
      thumbnail {
        publicUrl
      }
      country {
        id
        name
        slug
        bandera {
          publicUrl
        }
        region {
          id
          name
          slug
        }
      }
      tips {
        id
        title
        description
        type
        icon
      }
      packages {
        id
        title
        slug
        priceFrom
        imageCover {
          publicUrl
        }
      }
      posts {
        id
        title
        slug
        excerpt
        coverImage {
          publicUrl
        }
        publishedDate
      }
    }
  }
`;

// Consulta para obtener posts del blog
export const GET_POSTS = gql`
  query GetPosts($where: PostWhereInput, $take: Int, $skip: Int) {
    posts(where: $where, take: $take, skip: $skip, orderBy: { publishedDate: desc }) {
      id
      title
      slug
      excerpt
      content
      publishedDate
      isPublished
      coverImage {
        publicUrl
      }
      author {
        id
        name
      }
      tags {
        id
        name
        color
      }
      relatedDestinations {
        id
        title
        slug
      }
      relatedPackages {
        id
        title
        slug
      }
    }
    _postsMeta(where: $where) {
      count
    }
  }
`;

// Consulta para obtener un post específico por slug
export const GET_POST_BY_SLUG = gql`
  query GetPostBySlug($slug: String!) {
    post(where: { slug: $slug }) {
      id
      title
      slug
      excerpt
      content
      publishedDate
      isPublished
      coverImage {
        publicUrl
      }
      author {
        id
        name
      }
      tags {
        id
        name
        color
      }
      relatedDestinations {
        id
        title
        slug
        imageCover {
          publicUrl
        }
      }
      relatedPackages {
        id
        title
        slug
        priceFrom
        imageCover {
          publicUrl
        }
      }
    }
  }
`;

// Consulta para obtener regiones y países
export const GET_REGIONS_AND_COUNTRIES = gql`
  query GetRegionsAndCountries {
    regions(orderBy: { order: asc }) {
      id
      name
      slug
      order
      countries {
        id
        name
        slug
        bandera {
          publicUrl
        }
        destinations {
          id
          title
          slug
          imageCover {
            publicUrl
          }
        }
      }
    }
  }
`;

// Consulta para obtener eventos de viaje
export const GET_TRAVEL_EVENTS = gql`
  query GetTravelEvents {
    travelEvents {
      id
      name
      slug
      startDate
      endDate
      description
      image {
        publicUrl
      }
    }
  }
`;

// Consulta para obtener todos los alojamientos
export const GET_ALL_ACCOMMODATIONS = gql`
  query GetAllAccommodations {
    accommodations {
      id
      name
      slug
      category
      description
      coverImage {
        publicUrl
      }
      thumbnail {
        publicUrl
      }
      destination {
        id
        title
        slug
        country {
          id
          name
          slug
        }
      }
      packages {
        id
        title
        slug
        priceFrom
      }
    }
  }
`;

// Consulta para obtener un alojamiento específico por slug
export const GET_ACCOMMODATION_BY_SLUG = gql`
  query GetAccommodationBySlug($slug: String!) {
    accommodation(where: { slug: $slug }) {
      id
      name
      slug
      category
      description
      videoUrl
      coverImage {
        publicUrl
      }
      thumbnail {
        publicUrl
      }
      galleryImages {
        id
        altText
        image {
          publicUrl
        }
      }
      location
      reviews
      destination {
        id
        title
        slug
        imageCover {
          publicUrl
        }
        country {
          id
          name
          slug
          bandera {
            publicUrl
          }
        }
      }
      packages {
        id
        title
        slug
        priceFrom
        imageCover {
          publicUrl
        }
      }
    }
  }
`; 